<template>
  <div class="no-box-shadow-card card height-80 border-color-select">
    <div class="card-header height-80">
      <a class="card-header-icon is-cursor-pointer"
         @click="$emit('updateAfficheurSelect')">
        <b-icon :icon="isIconSelect ? 'check-circle' : 'checkbox-blank-circle-outline'"
                :type="isIconSelect ? 'is-primary' : ''">
        </b-icon>
      </a>
      <div class="imgFaceSansListe mgv-auto" v-if="firstLigne && displayLogo">
        <div class="imgFaceSansListe_logo">
        </div>
      </div>
      <img :src="logo" v-else-if="logo && !firstLigne && displayLogo" alt=""
           class="image is-32x32 mgv-auto mgr-20px"/>
      <avatar :username="afficheurInformation.afficheur" v-else-if="displayLogo" :size="32"
              class="mgv-auto mgl-12px mgr-20px"/>
      <div class="columns is-multiline height-fit-content mgv-auto">
        <div class="column is-12 pdv-0
            is-size-6 has-text-weight-bold height-fit-content has-text-link">
          {{ afficheurInformation.afficheur }}
        </div>
        <div class="column is-6 pdv-0
            is-size-7 height-fit-content is-size-7 has-text-default"
             v-if="afficheurInformation.nbFaces !== null">
          {{ $t('chargeTravailAff.ressourceAndAffectationInfo.nbFaces',
          { faces: afficheurInformation.nbFaces }) }}
        </div>
        <div class="column is-6 pdv-0
            is-size-7 height-fit-content is-size-7 has-text-default"
             v-if="nbListes !== 0">
             {{ $t('chargeTravailAff.ressourceAndAffectationInfo.nbListes',
              { listes: nbListes }) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Avatar from 'vue-avatar';
import getLogo from '@/services/general/getLogo';

export default {
  props: {
    afficheurInformation: {
      type: Object,
      required: true,
    },
    firstLigne: {
      type: Boolean,
      required: true,
    },
    displayLogo: {
      type: Boolean,
      required: true,
    },
    isIconSelect: {
      type: Boolean,
      required: true,
    },
    nbListes: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      logo: null,
    };
  },
  components: {
    Avatar,
  },
  async mounted() {
    if (!this.afficheurInformation.afficheurId) return;
    this.logo = await getLogo(this.afficheurInformation.afficheurId);
  },
};

</script>
